import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export function PartMatch({ form, setForm, houseId }) {
  const [types, setTypes] = useState(null);
  useEffect(() => {
    api.get("/admin/pumpjack/work-types", { params: { house_id: houseId } }).then((r) => setTypes(r.data)).catch(() => setTypes([]));
  }, [houseId]);
  const sel = form.part_work_types || [];
  const toggle = (t) => setForm({ ...form, part_work_types: sel.includes(t) ? sel.filter((x) => x !== t) : [...sel, t] });
  return (
    <div className="rounded-xl border p-3 space-y-2" data-testid="part-match">
      <Label>Which Pumpjack records belong to this part?</Label>
      <Input placeholder="Match words, e.g. wrist pin, wristpin" value={(form.part_keywords || []).join(", ")}
        onChange={(e) => setForm({ ...form, part_keywords: e.target.value.split(",").map((s) => s.trimStart()) })} data-testid="part-keywords" />
      <p className="text-[11px] text-slate-500">Separate words with commas, e.g. "wristpin, wrist pin, WP" (spaces are forgiven). Any work request, field ticket, inspection item or cost line that mentions one of them is shown on this part. Leave empty to match the title.</p>
      <p className="text-xs font-semibold pt-1">Or pick work types used on this well</p>
      {types === null ? <p className="text-xs text-slate-500">Loading work types…</p> : types.length === 0 ? <p className="text-xs text-slate-500">No work types found. Link the tour to a well first.</p> : (
        <div className="flex flex-wrap gap-1.5" data-testid="part-work-types">
          {types.map((t) => <button type="button" key={t} onClick={() => toggle(t)} className={`px-2.5 py-1 rounded-full border text-xs ${sel.includes(t) ? "bg-slate-900 text-white border-slate-900" : "bg-white"}`} data-testid={`part-type-${t}`}>{t}</button>)}
        </div>
      )}
    </div>
  );
}
